import { UsersDeleteModal } from './UsersDeleteModal'

export default UsersDeleteModal
